import { generateSectionMenus } from 'layouts/menuItems';
import { SectionStubDto } from 'models/dtoTypes';
import { useTranslation } from 'react-i18next';

export const useSmeMenuList = (sections: SectionStubDto[]) => {
  const { t } = useTranslation('default');
  return generateSmeMenuList(t, sections);
};

export function generateSmeMenuList(t: (key: string) => string, sections: SectionStubDto[]) {
  return [
    {
      label: t('company-details'),
      icon: 'CompanySvg',
      path: '/questionnaire',
      subItems: generateSectionMenus(sections),
    },
    {
      label: t('esg-ratings'),
      path: '/esg-ratings',
      icon: 'FinanceSvg',
    },
  ];
}
